<template>
  <div>
    <settings-layout
      v-model="configs"
      :items="configs"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :properties="properties"
      :status="status"
      :img="sourceImg"
      :testLoading="testLoading"
      :imgLoading="sourceImgLoading"
      @click:save="save"
      @click:test="test"
    >
      <template #actions v-if="configs.source_id">
        <b-dropdown-item @click="toDuplicate" aria-role="listitem">{{ $t('lists.duplicate') }}</b-dropdown-item>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </settings-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import SettingsLayout from '@/layout/SettingsLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Source',
  components: {
    SettingsLayout
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role,
      title: state => state.title
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      serversLoading: false,
      testLoading: false,
      sourceImgLoading: false,
      configs: {},
      properties: {},
      status: '',
      sourceImg: ''
    }
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push({
        name: 'sources',
        params: {
          server_id: this.$route.params.server_id
        }
      })
    }
    if (
      this.$route.query.duplicate !== undefined ||
      this.$route.query.type !== undefined ||
      this.$route.params.source_id !== undefined
    ) {
      this.getDefaultConfig()
    } else {
      this.$router.push({
        name: 'sources',
        params: {
          server_id: this.$route.params.server_id
        }
      })
    }
  },
  methods: {
    ...mapActions('general', ['setTitle']),
    ...mapActions('general', ['setServerName']),
    save() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/source`
      this.configs.name = this.title
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          source_config: this.configs
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$router.push({
            name: 'sources',
            params: {
              server_id: this.$route.params.server_id
            }
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
      //        .finally(() => {
      //          this.$router.go()
      //        })
    },
    toDuplicate() {
      this.$router.push({
        name: 'add_source',
        query: {
          duplicate: this.$route.params.source_id
        },
        params: {
          server_id: this.$route.params.server_id
        }
      })
    },
    duplicate() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/source/duplicate`
      this.serversLoading = true
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          source_id: this.$route.query.duplicate
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.configs = data.config
          this.properties = data.properties
          this.setTitle(this.configs.name)
          this.setServerName(data.server_name)
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.serversLoading = false
        })
    },
    test() {
      this.getImage(this.configs)
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/source/test`
      this.testLoading = true
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          source_config: this.configs
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(status => {
          this.status = status
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.testLoading = false
        })
    },
    getDefaultConfig() {
      if (!this.serversLoading) {
        if (this.$route.name === 'add_source' && this.$route.query.duplicate != undefined) {
          return this.duplicate()
        }

        const body = {
          server_id: this.$route.params.server_id
        }
        if (this.$route.query.type !== undefined) {
          body.type = this.$route.query.type
        }
        if (this.$route.params.source_id !== undefined) {
          body.source_id = this.$route.params.source_id
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/source?${searchParams}`
        this.serversLoading = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.configs = data.config
            this.properties = data.properties
            this.setTitle(this.configs.name)
            this.setServerName(data.server_name)
            if (
              this.$route.params.source_id !== undefined ||
              (this.$route.params.source_id === undefined && this.configs.source_id)
            ) {
              this.getImage(this.configs)
            }
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    getImage(source_config) {
      const body = {
        server_id: this.$route.params.server_id,
        source_config: JSON.stringify(source_config)
      }

      const searchParams = new URLSearchParams(body)
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/source/image?${searchParams}`
      this.sourceImgLoading = true
      return fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(sourceImg => {
          this.sourceImg = sourceImg
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.sourceImgLoading = false
        })
    },
    deleteSource() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/source/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          source_id: this.configs.source_id
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$router.push({
            name: 'sources',
            params: {
              server_id: this.$route.params.server_id
            }
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: this.configs.name
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteSource()
            .then(() => {
              this.$notify({
                message: this.$t('notification.removed', {
                  msg: this.configs.name
                }),
                type: 'success'
              })
            })
            .finally(() => {
              this.serversLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
